import React from 'react';
import { Link } from 'react-router-dom';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Footer from 'components/Footer/Footer.jsx';
import CreditsPackage from '../../components/CreditsPackage/CreditsPackage';
// sections for this page
import NavigationBar from 'components/inc/NavigationBar.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';

import MainPage from 'assets/jss/MainPageStyle.jsx';
import styles from 'assets/jss/customStyle.jsx';
import { Container } from '@material-ui/core';

class PurchasePackage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  render() {
    const { classes } = this.props;

    return (
      <main>
        <NavigationBar />
        <Container maxWidth='lg' component='section'>
          <CreditsPackage />
        </Container>
      </main>
    );
  }
}

export default withStyles(MainPage)(PurchasePackage);
